module.exports = __webpack_public_path__ + "media/images/it/hero-home_video-placeholder-238ecf4c0fa86e42bd45db2d72076c7d.jpg";